import { connect } from 'react-redux';
import type { Dispatch } from 'redux';
import { bindAction } from '../../../common/utils/actions.js';
import { toggleSelection } from '../../actions.js';
import SelectCell from './select-cell.js';

function mapDispatchToProps(
  dispatch: Dispatch,
  props: { tableName: string }
): { toggleSelection: ReturnType<typeof toggleSelection> } {
  return {
    toggleSelection: bindAction(toggleSelection, { multiSelectName: props.tableName }, dispatch)
  };
}

export default connect(null, mapDispatchToProps)(SelectCell);
